module.exports = __webpack_public_path__ + "static/media/company-profile-ad3.c0fd83e5.png";